<template>
  <BaseDialog
    v-model:is-visible="isVisible"
    :ui="{ title: 'text-error' }"
  >
    <template #title>
      <ExclamationTriangleIcon class="w-6 h-6" />
      {{ title }}
    </template>

    <p class="mb-6">
      {{ message }}
    </p>

    <div class="flex justify-end gap-3">
      <BaseButton
        variant="text"
        @click="isVisible = false"
      >
        Stay
      </BaseButton>
      <BaseButton
        color="error"
        @click="$emit('confirm')"
      >
        {{ confirmLabel }}
      </BaseButton>
    </div>
  </BaseDialog>
</template>

<script setup lang="ts">
import BaseButton from '@/components/BaseButton.vue';
import BaseDialog from '@/components/BaseDialog.vue';
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline';

withDefaults(defineProps<{
  title?: string
  message: string
  confirmLabel?: string
}>(), {
  title: 'Leave Classroom?',
  confirmLabel: 'Leave',
});
const isVisible = defineModel<boolean>('isVisible', { default: false });

defineEmits<{
  (e: 'confirm'): void
}>()
</script>
